module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dialog-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-menu",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "dialog-ctx"
  }, [_c('div', {
    staticClass: "cont"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("户政业务")]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.sfzjf()
      }
    }
  }, [_c('div', {
    staticClass: "menu-title"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-gengduo"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("窗口缴费")])]), _vm._v(" "), _c('span', {
    staticClass: "menu-desc"
  }, [_vm._v("窗口办理身份证缴费")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33676b76"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/household_dialog/household_dialog.vue
// module id = 313
// module chunks = 40